import { slices } from "@/constants/sliceNames";
import { createSlice } from "@reduxjs/toolkit";
import { WEBSOCKET_MESSAGE, DEFAULT_PREFIX } from "@giantmachines/redux-websocket";
import { EXECUTION_STATUS } from "@/store/effects/run-execution/util";

import { ExecutionStatuses } from "../../../constants/execution-statuses";
import { Prefixs } from "../../../socket/socketPrefix";
import {
  requestRunExecutionStatus,
  requestStopExecutionStatus,
} from "../../effects/run-execution/runExecution-effects";

const initialState = {
  isDone: false,
  isSuccess: false,
  executionStatus: "",
  inputs: null,
  outputs: null,
  isCanceled: false,
  executionProgress: 0,
};

const wsActions = (state, action) => {
  const msg = JSON.parse(action.payload.message);
  // check if the message is about app execution
  // and check if we still listing to it or not
  if (msg.messageName.startsWith("app-exec")) return handleWSMessage(state, msg);
  return state;
};

const runExecutionSlice = createSlice({
  name: slices.runExecution,
  initialState,
  reducers: {
    resetRunExecution: (state, action) => initialState,
    updateRunExecutionStatus: (state, action) => {
      state.executionStatus = action.payload.status;
    },
    updateRunExecutionProgress: (state, action) => {
      state.executionProgress = action.payload.progress;
    },
  },
  extraReducers: {
    ...requestRunExecutionStatus,
    ...requestStopExecutionStatus,
    [`${DEFAULT_PREFIX}::${WEBSOCKET_MESSAGE}`]: wsActions,
    [`${Prefixs.PREDICTION_PREFIX}::${WEBSOCKET_MESSAGE}`]: wsActions,
    [`${Prefixs.BATCH_PREDICTION_PREFIX}::${WEBSOCKET_MESSAGE}`]: wsActions,
    [`${Prefixs.TRAIN_PREFIX}::${WEBSOCKET_MESSAGE}`]: wsActions,
    [`${Prefixs.DEPLOY_PREFIX}::${WEBSOCKET_MESSAGE}`]: wsActions,
    [`${Prefixs.ANALYSIS_PREFIX}::${WEBSOCKET_MESSAGE}`]: wsActions,
  },
});

const handleWSMessage = (state, message) => {
  switch (message.messageName) {
    case "app-exec::exec-done":
      return {
        ...state,
        outputs: message.payload.output,
      };

    case "app-exec::progress":
      return {
        ...state,
        executionProgress:
          state.executionStatus === EXECUTION_STATUS.IN_PROGRESS
            ? message.payload.progress === 100
              ? 99
              : message.payload.progress
            : 0,
      };

    case "app-exec::status":
      return handleExecutionStatus(state, message.payload.status);
    default:
      return { ...state };
  }
};

const handleExecutionStatus = (state, status) => {
  switch (status) {
    case ExecutionStatuses.UNPROCESSED:
      return {
        ...state,
      };
    case ExecutionStatuses.IN_PROGRESS:
      return {
        ...state,
        executionStatus: EXECUTION_STATUS.IN_PROGRESS,
      };
    case ExecutionStatuses.SUCCEEDED:
      return {
        ...state,
        isSuccess: true,
        executionProgress: null,
        executionStatus: status,
        isDone: true,
      };
    case ExecutionStatuses.FAILED:
      return {
        ...state,
        executionStatus: status,
        isSuccess: false,
        executionProgress: null,
        isDone: true,
        // eslint-disable-next-line no-new-wrappers
        message: new String("Execution failed"),
      };
    case ExecutionStatuses.CANELED:
      return {
        ...state,
        executionProgress: 0,
        executionStatus: status,
        isCanceled: true,
        isDone: true,
      };
    default:
      return state;
  }
};

const { actions, reducer } = runExecutionSlice;

export const { resetRunExecution, updateRunExecutionStatus, updateRunExecutionProgress } = actions;

export default reducer;
